const CLASS = "focus-color";


export interface ILabel {
    label: HTMLElement;
    input?: HTMLElement;
    radios?: HTMLCollectionOf<HTMLElement>
    datePickerIcon?: Element;

    initializeListeners(): void;
    addColor(input?: HTMLElement): void;
    removeColor(input?: HTMLElement): void;
}


export class InputLabel implements ILabel {
    label: HTMLElement;
    input: HTMLElement;
    datePickerIcon: Element;

    constructor(labelDiv: HTMLElement, inputElement: HTMLElement) {
        this.label = labelDiv;
        this.input = inputElement;
        this.initializeListeners.bind(this);

        this.initializeDatePickerIcon();
    }

    initializeListeners() {
        this.input.addEventListener('focus', () => { this.addColor(this.input); });
        this.input.addEventListener('blur', () => { this.removeColor(this.input); });

        this.input.addEventListener('mouseenter', () => { this.addColor(this.input); });
        this.input.addEventListener('mouseleave', () => { this.removeColor(this.input); });
    }

    initializeDatePickerIcon() {
        if (this.input.classList.contains('form-element-input-datepicker')) {
            let datePickerIcon = this.searchDatePicker(this.input);
            if (datePickerIcon) {
                this.datePickerIcon = datePickerIcon;
            }
        } 

    }


    /**
     * Finds the datepicker icon element associated with the date picker input
     */
    searchDatePicker(tempParent: HTMLElement) {
        while (tempParent.tagName !== "BODY") {
            tempParent = tempParent.parentElement;
            if (tempParent.classList.contains('date-picker-container')) {
                let datePickerIcon = tempParent.querySelector('.date-picker-icon');
                if (datePickerIcon) {
                    return datePickerIcon;
                }
            }
        }
        return null;
    }

    addColor(input: HTMLElement) {
        if (!this.label.classList.contains(CLASS)) {
            this.label.classList.add(CLASS);
            if (this.datePickerIcon && !this.datePickerIcon.classList.contains(CLASS)) {
                this.datePickerIcon.classList.add(CLASS);   
            }   
        }
    }

    removeColor(input: HTMLElement) {
        var activeElement = document.activeElement;

        if (activeElement != input && this.label.classList.contains(CLASS)) {
            this.label.classList.remove(CLASS);
            if (this.datePickerIcon && this.datePickerIcon.classList.contains(CLASS)) {
                this.datePickerIcon.classList.remove(CLASS);
            }
        }
    }
}


export class RadioLabel implements ILabel {
    label: HTMLElement;
    radios: HTMLCollectionOf<HTMLElement>;

    constructor(labelDiv: HTMLElement, radioElements: HTMLCollectionOf<HTMLElement>) {
        this.label = labelDiv;
        this.radios = radioElements;
        this.initializeListeners.bind(this);
    }

    initializeListeners() {

        [].forEach.call(this.radios, radio => { radio.addEventListener('focus', () => { this.addColor(); }) });
        [].forEach.call(this.radios, radio => { radio.addEventListener('blur', () => { this.removeColor(radio); }) });

        [].forEach.call(this.radios, radio => { radio.addEventListener('mouseenter', () => { this.addColor(); }) });
        [].forEach.call(this.radios, radio => { radio.addEventListener('mouseleave', () => { this.removeColor(radio); }) });
    }

    addColor() {
        if (!this.label.classList.contains(CLASS)) {
            this.label.classList.add(CLASS);
        }
    }

    removeColor(radio: HTMLElement) {
        var activeElement = document.activeElement;
        let isActiveRadio = false;

        for (let i = 0; i < this.radios.length; i++) {
            if (activeElement == this.radios[i]) {
                isActiveRadio = true;
                break;
            }
        }

        if (!isActiveRadio && this.label.classList.contains(CLASS)) {
            this.label.classList.remove(CLASS);
        }
    }

}



